import type { ReactNode } from 'react';

export const symbol_mobile_chat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-100v-760 760Zm440 0v-120 120ZM580-340h240v-160H580v160Zm270 60H600l-54 54q-4 4-8.5 5t-8.5-1q-4-2-6.5-5.38-2.5-3.37-2.5-8.62v-294q0-12.75 8.63-21.38Q537.25-560 550-560h300q12.75 0 21.38 8.62Q880-542.75 880-530v220q0 12.75-8.62 21.37Q862.75-280 850-280ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24.75 17.63-42.38Q235.25-920 260-920h440q24.75 0 42.38 17.62Q760-884.75 760-860v170q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-170H260v760h440v-50q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50q0 24.75-17.62 42.37Q724.75-40 700-40H260Zm240-689q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm80 389v-160 160Z"
		/>
	</svg>
);
